import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styles from '../css/index.module.scss';
import MyButton from '../../../components/MyButton';
import useInputState from '../../../helpers/hooks/useInputState';
import Api from '../../../Api';
import ReselectIcon from '../../../assets/formIcons/reselect.svg';
import FormInput from '../../../components/FormInput';
import TableInput from '../../../components/TableInput';
import sendRequest from '../../../helpers/sendRequest';
import { updateArticle } from '../../../store/actions/articles';
import getFormData from '../../../helpers/getFormData';

function SingleArticleCard({ selectedArticle }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const fileInput = useRef(null);
  const { countries } = useSelector((store) => store.staticData);
  const { systemCountry } = useSelector((store) => store.account);

  const [name, setName, nameError, setNameError] = useInputState('');
  const [sort, setSort, sortError, setSortError] = useInputState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const onSaveClick = async () => {
    if (name?.length <= 2) {
      return setNameError('Минимум 2 символа');
    }

    const list = [];
    if (name !== selectedArticle.name) list.push(['name', name]);
    if (+sort !== +selectedArticle.sort) list.push(['sort', sort]);

    const formData = getFormData(
      { list },
      selectedFile ? [selectedFile] : [],
    );

    const data = await sendRequest({
      request: Api.editArticle,
      payload: { formData, id: selectedArticle._id, country_id: systemCountry?._id },
      setLoading,
    });

    if (data?.status === 'ok') {
      dispatch(updateArticle(data.article));
    }
  };

  const handleFile = (ev) => {
    if (ev.target.files?.length) {
      setSelectedFile(ev.target.files[0], true);
    }
  };

  useEffect(() => {
    if (selectedArticle) {
      setName(selectedArticle.name, true);
      setSort(selectedArticle.sort, true);
      setSelectedFile(null, true);
    }
  }, [selectedArticle]);

  return (
    <div>
      <MyButton
        secondary
        text="Сохранить"
        onClick={onSaveClick}
        className={styles.blockButton}
        loading={loading}
      />
      <MyButton
        secondary
        text="Переводы"
        onClick={() => navigate(`/translations?entity_type=articles&entity_id=${selectedArticle._id}`)}
        className={styles.blockButton}
      />
      <div className={styles.articleCard}>
        <div className={styles.articleCardTop}>
          <div className={styles.articleCardPhoto}>
            <input
              type="file"
              ref={fileInput}
              hidden
              onChange={handleFile}
              accept="image/png, image/jpeg"
            />
            <img
              className={styles.articleCardPhotoImg}
              src={selectedFile ? URL.createObjectURL(selectedFile) : Api.url + selectedArticle.photo_url}
              alt="file"
            />
            <div className={styles.articleCardPhotoFloat} onClick={() => fileInput.current?.click()}>
              <img src={ReselectIcon} alt="<" />
            </div>
          </div>
          <div className={styles.articleCardSortInput}>
            <TableInput
              value={sort}
              onChange={setSort}
              error={sortError}
              type="number"
              placeholder="Позиция в списке"
            />
          </div>
        </div>

        <TableInput
          value={name}
          onChange={setName}
          error={nameError}
        />
      </div>
    </div>
  );
}

export default SingleArticleCard;
